import { slug, zipProject } from './projects.js';

/** Downloads a project as `<name>.zip`. */
export function downloadZip(name: string, files: Map<string, Uint8Array>): void {
  const blob = new Blob([zipProject(name, files) as BlobPart], { type: 'application/zip' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${slug(name)}.zip`;
  document.body.append(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
}
